export default __webpack_public_path__ + "resources/icons/d232-2b10.png";